import NavBar from './navBar'

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="h-full">
      <NavBar />
      <div className="h-[95%]">{children}</div>
    </div>
  )
}
export default Layout
